import React, { useState, useEffect } from "react";
import ColorPicker from "react-best-gradient-color-picker";
import { rgbaToHex } from "@uiw/color-convert";

const parseRgbString = (rgbString) => {
  const match = rgbString.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
  return match ? {
    r: parseInt(match[1], 10),
    g: parseInt(match[2], 10),
    b: parseInt(match[3], 10),
    a: match[4] !== undefined ? parseFloat(match[4]) : 1,
  } : null;
};

const hexToRgb = (hex) => {
  hex = hex.replace(/^#/, "");
  if (hex.length === 3) hex = hex.split("").map((char) => char + char).join("");
  const bigint = parseInt(hex, 16);
  return `rgb(${(bigint >> 16) & 255}, ${(bigint >> 8) & 255}, ${bigint & 255})`;
};

const CustomGradientColorPicker = ({ hex = "#000000", onChange }) => {
  const [color, setColor] = useState(hexToRgb(hex));

  useEffect(() => {
    setColor(hexToRgb(hex));
  }, [hex]);

  const handleColorChange = (newColor) => {
    setColor(newColor);
    const rgbObject = parseRgbString(newColor);
    if (rgbObject && onChange) onChange({ hex: rgbaToHex(rgbObject) });
  };

  return (
    <div className='color-picker-modal'>
      <ColorPicker
        value={color}
        hidePresets
        hideOpacity
        hideColorTypeBtns
        hideAdvancedSliders
        hideColorGuide
        onChange={handleColorChange}
      />
    </div>
  );
};

export default CustomGradientColorPicker;
